import React, { useState, useEffect } from 'react'
import  './NewCollections.css'
import  Item from   '../Item/Item'

const NewCollections = () => {

    const [new_collection,setNew_collections] = useState([]);

    useEffect(()=>{
        fetch('http://localhost:4000/newcollections')
        .then((response)=>response.json())
        .then((data)=>setNew_collections(data));
    },[])
    return (
        <div className='new-collections'>
            <h1>Đang Giảm Giá Mạnh</h1> {/* NEW COLLECTION*/}
            <hr />
            <div className="collections">
                {new_collection.map((item,i)=>{
                    return  <Item key={i} id={item.id} name={item.name} image={item.image} new_price={item.new_price} old_price={item.old_price} />
                })}
            </div>
        </div> 
    )
}

export default NewCollections